import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Check if the user is authenticated
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  
  // Retrieve the token expiration time
  const expirationTime = localStorage.getItem('expires_in');
  const isTokenExpired = expirationTime && new Date().getTime() > parseInt(expirationTime, 10);

  // If token is expired, clear local storage
  if (isTokenExpired) {
    localStorage.clear();
  }

  // If not authenticated or token is expired, redirect to login page
  if (!isAuthenticated || isTokenExpired) {
    return <Navigate to="/login" replace />;
  }
  
  // If authenticated and token is not expired, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;